import { createSelector } from 'reselect';
import { isInArray } from '../../../core/util/is-in-array';
import { File } from '../../../vas/business-objects/file/file.model';
import { VasState } from '../../../vas/store/store-type';
import { FileMangerItemModel } from '../../atoms/file-manager-item/file-manger-item.model';

export const selectFileManager = (state: VasState) => state.fileManager;

export const selectFileManagerFiles = createSelector(selectFileManager, fm => fm.files);
const selectFileManagerFilter = createSelector(selectFileManager, fm => fm.filter);

export const selectFileManagerSelectedIds = createSelector(selectFileManager, fm => fm.selectedIds);
const selectFileManagerNewOrChangedIds = createSelector(selectFileManager, fm => fm.newOrChangedIds);
const selectFileManagerRemovedFiles = createSelector(selectFileManager, fm => fm.removedFiles);

const selectFileManagerFilteredFiles = createSelector(selectFileManagerFiles, selectFileManagerFilter, (files, filter) => {

    return files.filter(file => {

        if (filter.searchTerm && file.name.toLowerCase().indexOf(filter.searchTerm.toLowerCase()) === -1) {
            return false;
        }

        if (filter.groups.length && !isInArray(file.config.group, filter.groups)) {
            return false;
        }

        return true;
    });
});

export const selectFileManagerFileModels = createSelector(
    selectFileManagerFilteredFiles,
    selectFileManagerSelectedIds,
    (files, selectedIds) => {
        return files.map(file => ({
            file,
            isSelected: !!selectedIds.find(id => file.id === id)
        } as FileMangerItemModel));
    });

export const selectFileManagerSubmit = createSelector(
    selectFileManagerNewOrChangedIds,
    selectFileManagerFiles,
    selectFileManagerRemovedFiles,
    (ids, files, removedFiles): {save: Array<File>, remove: Array<File>} => {

        return {
            save: files.filter(file => isInArray(file.id, ids)),
            remove: removedFiles
        };
    }
);



// WEBPACK FOOTER //
// ./src/app/molecules/file-manager/file-manager.selectors.ts